
    import { defineComponent } from "vue";
    import GameService from "@/services/GameService";
    import ResponseData from "@/_models/ResponseData";
    import store from "@/store/index";
    import { Helper } from "@/utils/Helper";
    
    export default defineComponent({
      data: function () {
        return {
          userData: store.getters["auth/user"] ?? "",
          jwtToken: store.getters["auth/jwtToken"] ?? "",
          stepCount: 0,
          coverImage: "",
          gameDetails: [],
          about: "",
          username: "",
          gallery: [],
          languages: [],
        };
      },
    
      name: 'gamesGalleryComponent',
      methods: {
        prevSlide() {
          --this.stepCount;
          if(this.stepCount == 0){
            for(let i = 0; i < this.gallery.length; i++){
              if(0 <=i && i <= 2){
                this.gallery[i].display = true;
              }else{
                this.gallery[i].display = false;
              }
            }
          }else if(this.stepCount == 1){
            for(let i = 0; i < this.gallery.length; i++){
              if(3 <=i && i <= 5){
                this.gallery[i].display = true;
              }else{
                this.gallery[i].display = false;
              }
            }
          }
        },
        nextSlide() {
          ++this.stepCount;
          if(this.stepCount == 1){
            for(let i = 0; i < this.gallery.length; i++){
              if(3 <=i && i <= 5){
                this.gallery[i].display = true;
              }else{
                this.gallery[i].display = false;
              }
            }
          }else if(this.stepCount == 2){
            for(let i = 0; i < this.gallery.length; i++){
              if(6 <=i && i <= 8){
                this.gallery[i].display = true;
              }else{
                this.gallery[i].display = false;
              }
            }
          }
        },
    
        currentSlide() {
          console.log("current");
        },
    
        getGameDetails() {
          if (this.$route.params.gameId !== undefined && this.userData !== "") {
            let gameId = this.$route.params.gameId.toString();
    
            GameService.getGame(gameId)
              .then((response: ResponseData) => {
                if (response.status === 200) {
                  this.gameDetails = response.data.viewModel.game;
                  this.username = this.userData.username;
                  this.gameDetails.created = Helper.formatDate(this.gameDetails.created);
                  this.gameDetails.updated = Helper.formatDate(this.gameDetails.updated);
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.about !== null) {
                    this.about = response.data.viewModel.details.about.about;
                  }
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.headerImage !== null) {
                    this.coverImage = this.assetUrl + "blob/games/" + gameId + "/gallery/" + response.data.viewModel.details.gallery.headerImage;
                  }
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.galleryImages !== []) {
                    response.data.viewModel.details.gallery.galleryImages.forEach((image, index) => {
                      this.gallery.push({
                        id: index + 1,
                        url: this.assetUrl + "blob/games/" + gameId + "/gallery/" + image,
                        itemCount: index + 1,
                        display: index > 2 ? false : true,
                      });
                    });
                  }
                  // this.maxStep = this.gallery.length <= 3 ? 0 : Math.floor(this.gallery.length / 3);
                  // this.gallery = this.groupGalleryByThree(this.gallery);
                }
              })
              .catch((error) => {
                Helper.endpointErrorHandling(error);
              });
          }
        },

        removeImageGallery(item: any) {
          let gameId = this.$route.params.gameId.toString();
          let imageFile = item.url.lastIndexOf('/');
          let imageId = item.url.substring(imageFile + 1);

          GameService.removeGameGallery(gameId, this.userData.userId, this.jwtToken, imageId)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data["message"]);
              this.isUploading = false;
              for (let i = 0; i < this.gallery.length; i++) {
                if (this.gallery[i].url == item.url) {
                  this.gallery.splice(i, 1);
                }
              }
              this.forceRerenderGallery();
          }).catch((error) => {
              Helper.endpointErrorHandling(error);
          });
        },
    
        groupGalleryByThree(data) {
          let result = [];
          for (let i = 0; i < data.length; i += 3) result.push(data.slice(i, i + 3));
          return result;
        },
    
        
      },
    
      computed: {
        testnetLabel() {
          return store.getters['config/configTestnetLabel'];
        },
        assetUrl() {
          return store.getters['config/assetUrl'];
        },
        isEnabledGalleryPreviousButton() {
          return this.stepCount > 0;
        },
    
        isEnabledGalleryNextButton() {
          return this.gallery.length > ((this.stepCount + 1) * 3);
        },
      },
    
      mounted() {
        this.getGameDetails();
      },
    });
    